<table
  id="invoice-preview-container"
  class="k-pos-relative k-w-full k-h-full"
  [ngStyle]="{
    '--document-theme-color': themeProps().themeColor,
    '--footer-background-color': themeProps().footerBackgroundColor,
  }"
>
  @let sectionIds = StandardSectionIds;
  @let areas = contentAreas();
  @let currentMode = mode();
  @let metaData = meta();

  <thead class="invoice-preview-header">
    <tr>
      <th>
        <div class="header-info">
          <header>
            @let logoArea = areas.get(sectionIds.HeaderImage);
            @let stylingConfig = { classes: ["!k-mb-12", "k-ml-13px"] };
            {{ logoArea.content }}
            <div
              appEditDocumentSections
              [mode]="currentMode"
              [sectionId]="sectionIds.HeaderImage"
              [contentArea]="logoArea"
              [editWrapperConfig]="stylingConfig"
            >
              <img
                [ngSrc]="logoArea?.meta?.src"
                [alt]="logoArea?.meta?.alt || ''"
                priority
                [width]="logoArea?.meta?.width"
                [height]="logoArea?.meta?.height"
              />
            </div>

            @let headerTextArea = areas.get(sectionIds.HeaderText);
            <div
              class="contact-info"
              appEditDocumentSections
              [mode]="currentMode"
              [sectionId]="sectionIds.HeaderText"
              [contentArea]="headerTextArea"
              [editWrapperConfig]="stylingConfig"
              [meta]="metaData"
              [innerHTML]="headerTextArea?.content | safeHtml: SecurityContext.HTML"
            ></div>
          </header>
        </div>
      </th>
    </tr>
  </thead>

  <tfoot class="invoice-preview-footer">
    <tr>
      <td>
        <footer>
          @let footerOneArea = areas.get(sectionIds.FooterOne);
          @let footerTwoArea = areas.get(sectionIds.FooterTwo);
          @let footerThreeArea = areas.get(sectionIds.FooterThree);
          @let footerFourArea = areas.get(sectionIds.FooterFour);

          <div
            appEditDocumentSections
            [mode]="currentMode"
            [sectionId]="sectionIds.FooterOne"
            [contentArea]="footerOneArea"
            [meta]="metaData"
            [innerHTML]="footerOneArea?.content | safeHtml: SecurityContext.HTML"
          ></div>

          <div
            appEditDocumentSections
            [mode]="currentMode"
            [sectionId]="sectionIds.FooterTwo"
            [contentArea]="footerTwoArea"
            [meta]="metaData"
            [innerHTML]="footerTwoArea?.content | safeHtml: SecurityContext.HTML"
          ></div>

          <div
            appEditDocumentSections
            [mode]="currentMode"
            [sectionId]="sectionIds.FooterThree"
            [contentArea]="footerThreeArea"
            [meta]="metaData"
            [innerHTML]="footerThreeArea?.content | safeHtml: SecurityContext.HTML"
          ></div>

          <div
            style="justify-content: center"
            appEditDocumentSections
            [mode]="currentMode"
            [sectionId]="sectionIds.FooterFour"
            [contentArea]="footerFourArea"
          >
            <div class="k-text-center">
              <img
                [ngSrc]="footerFourArea?.meta?.src"
                [alt]="footerFourArea?.meta?.alt || ''"
                [width]="footerFourArea?.meta?.width"
                [height]="footerFourArea?.meta?.height"
              />
            </div>
          </div>
        </footer>
      </td>
    </tr>
  </tfoot>

  <tbody class="invoice-content">
    <tr>
      <td class="k-align-top">
        <div class="invoice-content-section-wrapper">
          @let contentOneArea = areas.get(sectionIds.ContentOne);
          <section
            appEditDocumentSections
            [mode]="currentMode"
            [sectionId]="sectionIds.ContentOne"
            [contentArea]="contentOneArea"
            [meta]="metaData"
            [innerHTML]="contentOneArea?.content | safeHtml: SecurityContext.HTML"
          ></section>

          <section class="table-section k-mt-8">
            <app-draggable-financial-records-table [invoicePositions]="invoicePositions()" />
          </section>

          @let contentTwoArea = areas.get(sectionIds.ContentTwo);
          <section
            class="about-invoice-section k-mt-5"
            appEditDocumentSections
            [mode]="currentMode"
            [sectionId]="sectionIds.ContentTwo"
            [contentArea]="contentTwoArea"
            [meta]="metaData"
            [innerHTML]="contentTwoArea?.content | safeHtml: SecurityContext.HTML"
          ></section>
        </div>
      </td>
    </tr>
  </tbody>
</table>
